import api from '../index'

export const getMessages = (courseId: number, identifier = 0) => {
  return api
    .get(`courses/${courseId}/conversations`)
    .then(({ data: { data } }) => {
      if (data) {
        const {
          id: conversationId,
          attributes: {
            user: to,
            messages: { data: messageData },
          },
        } = data
        let messages = [] as any
        if (messageData.length > 0) {
          messages = messageData.map(
            ({
              id: messageId,
              attributes: { user: from, content, read, attachments, createdAt },
            }: any) => {
              let hasBeenRead = true
              if (!read) {
                if (identifier !== from.identifier) hasBeenRead = false
              }
              return {
                messageId,
                from,
                content,
                read: hasBeenRead,
                attachments,
                createdAt,
              }
            }
          )
        }
        return { conversationId, to, messages }
      }
      return { conversationId: 0, to: {}, from: {} }
    })
}

export const getConversationMessages = (
  conversationId: number,
  identifier: number
) => {
  return api
    .get(`home/conversations/${conversationId}`)
    .then(({ data: { data } }) => {
      const {
        id: conversationId,
        attributes: {
          user: to,
          messages: { data: messageData },
        },
      } = data
      let messages = [] as any
      if (messageData.length > 0) {
        messages = messageData.map(
          ({
            id: messageId,
            attributes: { user: from, content, read, attachments, createdAt },
          }: any) => {
            let hasBeenRead = true

            if (!read && identifier !== from.identifier) hasBeenRead = false

            return {
              messageId,
              from,
              content,
              hasBeenRead,
              attachments,
              createdAt,
            }
          }
        )
      }
      return { conversationId, to, messages }
    })
}

export const getConversations = (token: string) => {
  return api.get(`home/conversations`).then(({ data: { data } }) => {
    if (data.length > 0) {
      const conversations = data.map(
        ({
          id: conversationId,
          attributes: {
            user: conversationOwner,
            otherUser,
            course: { id: courseId, name: courseName },
            messages: { data: messages },
          },
        }: any) => {
          const userToShow = otherUser || conversationOwner

          let lastMessage = {
            id: 0,
            read: true,
            content: '',
            owner: false,
            createdAt: new Date(),
          }
          if (messages.length > 0) {
            const {
              id,
              attributes: { user: from, content, read, createdAt },
            } = messages[messages.length - 1]
            lastMessage = {
              id,
              read,
              content,
              createdAt,
              owner: from.token === token,
            }
          }
          return {
            conversationId,
            courseId,
            owner: conversationOwner.id,
            courseName,
            userToShow,
            lastMessage,
          }
        }
      )
      return conversations
    }
    return []
  })
}

export const getCourseUnreadMessagesCount = (courseId: number) => {
  return api
    .get(`/courses/${courseId}/messages`)
    .then(({ data: { messages } }) => {
      return messages
    })
}

export const getUnreadMessagesCount = () => {
  return api.get(`/home/messages`).then(({ data: { messages } }) => {
    return messages
  })
}
